import { useDataFormStore } from "@/stores/form";
import { getArrayOfRules } from "@/utils/getDataForm";
import { checkDayToDay } from "@/utils/changeDate";
import { ref } from "vue";
import { tabRemove, tabAdd, getSlidersTabKey } from "@/utils/tabsFunctions";
import { getCargoTabKey } from "@/utils/tabsFunctions";
import { tabRefreshPackages } from "@/utils/tabsFunctions";
import { refreshPackagesAPI } from "@/utils/refreshPackages";

import {
  ServicesPartial,
  ServicesPartialTab,
} from "@/partials";


export default {
  
  components: {
    ServicesPartial,
    ServicesPartialTab,
  },

  setup() {

    window.addEventListener('pointerup', function(){
      if(Number(dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoVolume) < 0.004) dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoVolume = 0.004
      if(Number(dataForm.cargoInformation.cargoVolume) < 0.004) dataForm.cargoInformation.cargoVolume = 0.004

      if(Number(dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight) < 1) dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight = 1
      if(Number(dataForm.cargoInformation.cargoWeight) < 1) dataForm.cargoInformation.cargoWeight = 1
      
      if(dataForm.consignee?.cityTo.includes('(Москва)') && Number(dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight) > 300) dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight = 300
      if(dataForm.consignee?.cityTo.includes('(Москва)') && Number(dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight) < 50) dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight = 50

      if(Number(dataForm.cargoInformation.cargoWeight) < 50 && dataForm.consignee?.cityTo.includes('(Москва)')) dataForm.cargoInformation.cargoWeight = 50
      if(Number(dataForm.cargoInformation.cargoWeight) > 300 && dataForm.consignee?.cityTo.includes('(Москва)')) dataForm.cargoInformation.cargoWeight = 300
      
      if (dataForm.events.selecting) {
        changeСargoWeight();
        changeСargoWeightTab();
        changeСargoVolume();
        changeСargoVolumeTab();
      }
      
      dataForm.events.selecting = false;
    })

    const dialogText = ref();
    const dialogTitle = ref();

    // const cargoSpaceData = ref('1');

    
    const visible = ref(false)

    

    
    
    const cargoSpaceTabsEdit = (targetName, action) => {
      tabRemove(targetName, action);
    }

    const addTab = () => {
      tabAdd();
    }

    const changeСargoVolumeTab = () => {
      
      let VolumeRangeInputValue = dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoVolumeSlider;
      let value;

      

      if (VolumeRangeInputValue < 4) {
        value = 0.004
      } else if (VolumeRangeInputValue < 1000) {
          value = (VolumeRangeInputValue * 0.001).toFixed(3)
      } else if (VolumeRangeInputValue < 1945) {
          value = ((VolumeRangeInputValue - 900) / 105).toFixed(1)
      } else if (VolumeRangeInputValue >= 1945) {
          value = 10
      }

      dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].length  = (Math.cbrt(value)*100).toFixed(2);
      dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].width   = (Math.cbrt(value)*100).toFixed(2);
      dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].height  = (Math.cbrt(value)*100).toFixed(2);

      dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoVolume = value;

      
      
    }
    

    const printСargoVolume = () => {
      let val = dataForm.cargoInformationSliders.cargoVolumeSlider;

      if (val < 4) {
        val = 0.004
      } else if (val < 1000) {
        val = (val * 0.001).toFixed(3)
      } else if (val < 1945) {
        val = ((val - 900) / 105).toFixed(1)
      } else if (val >= 1945) {
        val = 10
      }
      
      return val;
    }

    const changeСargoWeight = () => {
      
    }

    const changeСargoWeightTab = () => {
      
    }

    const getTabsValidate = () => {
      let validate = true;

      let errorTabName = false;

      dataForm.cargoSpaceTabs.forEach(tab => {

        tab.errorNatureOfCargo = false;

        if ([23,47,67,68,69].includes(tab.natureOfCargo.id)) {
          if (dataForm.consigneeInnRadio == true) {
            if(dataForm.other.cargoCost > 10000) {
              tab.errorNatureOfCargo = "Укажите сумму обьявленной стоимости груза не более 10000 рублей"
            }
          } else {
            if(dataForm.other.cargoCost > 3000) {
              tab.errorNatureOfCargo = "Укажите сумму обьявленной стоимости груза не более 3000 рублей"
            }
          }
        }
        if(tab.natureOfCargo == []) tab.errorNatureOfCargo = "Пожалуйста выберите характер груза"
        
        if (tab.errorNatureOfCargo) errorTabName = tab.name;

        validate = validate && !tab.errorNatureOfCargo
      });

      if(errorTabName) {
        dataForm.cargoSpaceData = errorTabName;
      }

      return validate;
    }

    const changeСargoVolume = () => {

      let VolumeRangeInputValue = dataForm.cargoInformationSliders.cargoVolumeSlider;
      let value;

      if (VolumeRangeInputValue < 4) {
          value = 0.004
      } else if (VolumeRangeInputValue < 1000) {
          value = (VolumeRangeInputValue * 0.001).toFixed(3)
      } else if (VolumeRangeInputValue < 1945) {
          value = ((VolumeRangeInputValue - 900) / 105).toFixed(1)
      } else if (VolumeRangeInputValue >= 1945) {
          value = 10
      }
      

      dataForm.cargoInformation.cargoDimensions.length  = (Math.cbrt(value) * 100).toFixed(2)
      dataForm.cargoInformation.cargoDimensions.width   = (Math.cbrt(value) * 100).toFixed(2)
      dataForm.cargoInformation.cargoDimensions.height  = (Math.cbrt(value) * 100).toFixed(2)

      dataForm.cargoInformation.cargoVolume = value;

      
    }

    const changeMaxСargoVolume = () => {

      let value = Number(dataForm.cargoInformation.cargoVolume.toString().replace(/,/g, '.'));

      dataForm.cargoInformation.cargoDimensions.length  = (Math.cbrt(value) * 100).toFixed(2)
      dataForm.cargoInformation.cargoDimensions.width   = (Math.cbrt(value) * 100).toFixed(2)
      dataForm.cargoInformation.cargoDimensions.height  = (Math.cbrt(value) * 100).toFixed(2)

      let VolumeRangeInputValue = 1

      if(value <= 0.004) {
        VolumeRangeInputValue = 1
      } else if (value <= 1) {
        VolumeRangeInputValue = (value* 1000).toFixed()
      } else if (value <= 10) {
        VolumeRangeInputValue = (value * 105 + 900).toFixed()
      } else if (value > 10) {
        VolumeRangeInputValue = 2000
      }

      dataForm.cargoInformationSliders.cargoVolumeSlider = Number(VolumeRangeInputValue);

      

    }

    

    const dataForm = useDataFormStore();

    const typeOfCargos = [
      {
        value: "Стандарт",
        label: "Стандарт",
      },
      {
        value: "Цилиндры",
        label: "Цилиндры",
      },
      {
        value: "Шины",
        label: "Шины",
      },
    ];

    function handlerWeight() {
      if (
        
        checkDayToDay(dataForm.applicationCargoPickup.pickupDate) &&
        checkHour() &&
        checkWeight() &&
        checkCity()
      ) {
        dataForm.cargoInformation.cargoWeight = 30;
      }
      dataForm.updateApplicationTimeIsOver()
    }

    const checkCity = () =>
      dataForm.sender.cityFrom === "Челябинск" ||
      dataForm.sender.cityFrom === "Екатеринбург";

    

    const checkWeight = () => dataForm.cargoInformation.cargoWeight > 30;

    const checkHour = () => new Date().getHours() >= 12;

    return {
      consigneeInnRadioChange: function() {
        dataForm.cargoSpaceTabs.forEach(el => {
          let tabName = el.counter;
          tabRefreshPackages(undefined, tabName);
        });
        
        refreshPackagesAPI(undefined);
      },
      changeCargoCost: function() {
        dataForm.cargoSpaceTabs.forEach(el => {
          let tabName = el.counter;
          tabRefreshPackages(undefined, tabName);
        });

        refreshPackagesAPI(undefined);
      },
      getTabsValidate,
      addTab,
      cargoSpaceTabsEdit,
      changeСargoWeight,
      changeMaxСargoVolume,
      changeСargoVolumeTab,
      changeСargoWeightTab,
      printСargoVolume,
      changeСargoVolume,
      dataForm,
      typeOfCargos,
      getArrayOfRules,
      checkDayToDay,
      checkHour,
      checkWeight,
      checkCity,
      handlerWeight,
      visible,
      dialogText,
      dialogTitle,
      debug: function (text) {
        console.log(text)
      },
      cargoWeightInputChange: function () {
        let value = Number(dataForm.cargoInformation.cargoWeight.toString().replace(/,/g, '.'))

        let VolumeRangeInputValue = 1

        if(value <= 1) {
          VolumeRangeInputValue = 1
        } else if (value <= 201) {
          VolumeRangeInputValue = value
        } else if (value > 201) {
          VolumeRangeInputValue = 201
        }

        dataForm.cargoInformationSliders.cargoWeightSlider = Number(VolumeRangeInputValue);

        
      },
      cargoWeightInputChangeTab: function () {
        
        let value = Number(dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight.toString().replace(/,/g, '.'))

        let VolumeRangeInputValue = 1

        if(value <= 1) {
          VolumeRangeInputValue = 1
        } else if (value <= 201) {
          VolumeRangeInputValue = value
        } else if (value > 201) {
          VolumeRangeInputValue = 201
        }

        dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoWeightSlider = Number(VolumeRangeInputValue);

        
      },
      checkNumberOfIdenticalLoads: function () {
        if (dataForm.cargoInformation.numberOfIdenticalLoads < 1) {
          dataForm.cargoInformation.numberOfIdenticalLoads = 1;
        }
      },
      printСargoVolumeTab: function () {
      
        let VolumeRangeInputValue = dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoVolumeSlider;
        let value;
  
        if (VolumeRangeInputValue < 4) {
          value = 0.004
        } else if (VolumeRangeInputValue < 1000) {
            value = (VolumeRangeInputValue * 0.001).toFixed(3)
        } else if (VolumeRangeInputValue < 1945) {
            value = ((VolumeRangeInputValue - 900) / 105).toFixed(1)
        } else if (VolumeRangeInputValue >= 1945) {
            value = 10
        }
  
        return value;
  
      },
      changeMaxСargoVolumeTab: function () {

        let value = Number(dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoVolume.toString().replace(/,/g, '.'));
  
        
        dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].length  = (Math.cbrt(value)*100).toFixed(2);
        dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].width   = (Math.cbrt(value)*100).toFixed(2);
        dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].height  = (Math.cbrt(value)*100).toFixed(2);
        
        let VolumeRangeInputValue = 1

        if(value <= 0.004) {
          VolumeRangeInputValue = 1
        } else if (value <= 1) {
          VolumeRangeInputValue = (value* 1000).toFixed()
        } else if (value <= 10) {
          VolumeRangeInputValue = (value * 105 + 900).toFixed()
        } else if (value > 10) {
          
          VolumeRangeInputValue = 2000
        }

        dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoVolumeSlider = Number(VolumeRangeInputValue);

        
  
      },
      checkCargoCost: function () {
        if (dataForm.other.cargoCost < 3000) {
          dataForm.other.cargoCost = 3000;
        }
        
      },

      calculateVolumeTab: function () {
        if (
          dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].length &&
          dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].width &&
          dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].height
        ) {
          dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoVolume =
            ((dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].length *
              dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].width *
              dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].height) /
            1000000).toFixed(3);
        }
      },

      cargoWeightSliderSwitch: function () {
        if (dataForm.events.selecting) {
          if(dataForm.cargoInformationSliders.cargoWeightSlider == 201) {
            dataForm.cargoInformation.cargoWeight = 201
          }
        }

        let value = Number(dataForm.cargoInformationSliders.cargoWeightSlider)

        let VolumeRangeInputValue = 1

        if(value <= 1) {
          VolumeRangeInputValue = 1
        } else if (value <= 201) {
          VolumeRangeInputValue = value
        } else if (value > 201) {
          VolumeRangeInputValue = 201
        }

        dataForm.cargoInformation.cargoWeight = Number(VolumeRangeInputValue);

        
      },

      cargoWeightSliderSwitchTab: function () {
        if (dataForm.events.selecting) {
          dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight = dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoWeightSlider
        }

        if (dataForm.events.selecting) {
          if(dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoWeightSlider == 201) {
            dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight = 201
          }
        }

        let value = Number(dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoWeightSlider)

        let VolumeRangeInputValue = 1

        if(value <= 1) {
          VolumeRangeInputValue = 1
        } else if (value <= 201) {
          VolumeRangeInputValue = value
        } else if (value > 201) {
          VolumeRangeInputValue = 201
        }

        dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoWeight = Number(VolumeRangeInputValue);

        
      },

      cargoVolumeSliderSwitch: function () {
        if(dataForm.events.selecting) {
          if(dataForm.cargoInformationSliders.cargoVolumeSlider == 2000) {
            dataForm.cargoInformation.cargoVolume = 10;
          }
        }

        changeСargoVolume();
      },

      cargoVolumeSliderSwitchTab: function () {
        if(dataForm.events.selecting) {
          if(dataForm.cargoInformationSlidersTabs[getSlidersTabKey(dataForm.cargoSpaceData)].cargoVolumeSlider == 2000) {
            dataForm.cargoSpaceTabs[getCargoTabKey(dataForm.cargoSpaceData)].cargoVolume = 10;
          }
        }

        changeСargoVolumeTab();
      },
      calcAllWeight() {
        let weight = 0;
        dataForm.cargoSpaceTabs.forEach(el => {
          weight += parseInt(el.cargoWeight);
        });
        return weight;
      },
      calculateVolumeCylinder: function () {
        if (
          dataForm.cargoInformation.sizeOfCargoCylinder.diameter &&
          dataForm.cargoInformation.sizeOfCargoCylinder.height
        ) {
          dataForm.cargoInformation.cargoVolume =
            ((dataForm.cargoInformation.sizeOfCargoCylinder.diameter *
            dataForm.cargoInformation.sizeOfCargoCylinder.diameter *
            dataForm.cargoInformation.sizeOfCargoCylinder.height) /
            1000000).toFixed(3);
        }
      },

      calculateVolume: function () {
        if (
          dataForm.cargoInformation.cargoDimensions.length &&
          dataForm.cargoInformation.cargoDimensions.width &&
          dataForm.cargoInformation.cargoDimensions.height
        ) {
          dataForm.cargoInformation.cargoVolume =
            ((dataForm.cargoInformation.cargoDimensions.length *
              dataForm.cargoInformation.cargoDimensions.width *
              dataForm.cargoInformation.cargoDimensions.height) /
            1000000).toFixed(3);
        }
      },
      backButtonActionFirstPage: function () {
        dataForm.sender.first_step_pass = !dataForm.sender.first_step_pass; 
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },

      calculateDimensions: function () {
        const size = Math.round(
          Math.cbrt(Number(dataForm.cargoInformation.cargoVolume) * 1000000)
        ).toFixed(0);
        dataForm.cargoInformation.cargoDimensions.length = size;
        dataForm.cargoInformation.cargoDimensions.width = size;
        dataForm.cargoInformation.cargoDimensions.height = size;
      },
    };
  },
};
